export default "__VITE_ASSET__BLE96kcP__"